// extracted by mini-css-extract-plugin
export default {"brandPromo":"uH-z","carousel":"vH-z"};